<div class="headerdiv">
    <div>
      <h3 class="pagetitle">Pending Ads</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
    <div style="padding: 30px">
    <div class="row">
        <div class="pendingeventdiv" *ngFor="let el of pendingAds">
          <p class="eventtitle">{{el.name}}</p>
          <img class="eventimg"
            src="https://events.globalistic.tech{{el.image}}">
          <div class="row">
            <div class="col option1">
              Ad ID
            </div>
            <div class="col">
              {{el.id}}
            </div>
          </div>
          <div class="row">
            <div class="col option1">
              URL
            </div>
            <div class="col">
              {{el.link}}
            </div>
          </div>
          <div class="row">
            <div class="col option1">
              Description
            </div> 
            <div class="col">
              {{el.description}}
            </div>
          </div>
          <div class="row">
            <div class="col option1">
              Package
            </div>
            <div class="col">
              {{el.ad_package[0].package[0].name}}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col option1">
              Country
            </div>
            <div class="col">
              {{el.country}}
            </div>
          </div> -->
        
          <div class="row divfooter">
            <div class="col">
              <mat-icon (click)="acceptEvent(el.id)" class="accept">done</mat-icon>
            </div>
            <div class="col">
              <mat-icon (click)="showCancellation(el.id)" class="reject">close</mat-icon>
            </div>
          </div>
        </div> 
      </div>
    </div>
  
  
  
  <!-- Cancellation Reason Modal -->
  
  <div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">Reject Event</h4>
          <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
            class="material-icons">highlight_off</i>
  
        </div>
        <div style="display: inline-block;">
  
          <div class="modal-body">
           
            <mat-label>Are you sure you want to reject this event?</mat-label>
  
            <button (click)="rejectEvent()" class="confirmcancellation">Confirm Rejection</button>
          </div>
          <div class="modal-footer">
  
          </div>
        </div>
      </div>
    </div>
  </div>
  